import React from 'react';
import { IStaffTurnItem } from '../TurnTable/TurnStaffTopRow';
import styled from 'styled-components';
import clsx from 'clsx';
import Text from 'components/Text';
import { IStaffAvailableItem } from 'services/shop/types/staff';
import { Avatar } from 'antd';
import Box from 'components/Box';
import colorTheme from 'constants/color';
const getIndex = (index: number) => {
  switch (index) {
    case 1: return '1st';
    case 2: return '2nd';
    case 3: return '3rd';
    default:
      return `${index}th`;
  }
};
type Props = {
  index: number;
  data: IStaffTurnItem;
  highlight?: boolean;
};
const Staff = ({ data, index, highlight }: Props) => {
  return (
    <Container className={clsx(highlight && 'highlight')}>
      <div className='box-text'>
        <Text variant='CONTENT_2' className='text-overflow'>{getIndex(index)} - {data.staffName}</Text>
      </div>
    </Container>
  );
};
type StaffManagerProps = {
  data: IStaffAvailableItem;
};
export const StaffManager = ({ data }: StaffManagerProps) => {
  return (
    <Container>
      <div className='box-text' style={{ gap: '8px' }}>
        <Avatar size={40} src={data.staffAvatar} alt={data.staffName}>{data.staffName?.[0]}</Avatar>
        <Text variant='CONTENT_2' className='text-overflow'>{data.staffName}</Text>
      </div>
    </Container>
  );
};

export default Staff;

export const StaffTurn = ({ data, index, highlight }: Props) => {
  return (
    <Container className={clsx('staff-turn-box', highlight && 'highlight-turns')}>
        <Box display='flex' alignItems='center' gap='2'>
          <div className={clsx('index-text', highlight && 'highlight-index')}>
            {index}
          </div>
          <Text variant='CONTENT_2' className='text-overflow'>{data.staffName}</Text>
        </Box>
        <Text variant='CONTENT_2' className={clsx('turns-text', highlight && 'highlight-turns')}>
          {highlight ? 'Next' : `${getIndex(index)}`}
        </Text>
    </Container>
  );
};

export const StaffTurnManager = ({ data }: StaffManagerProps) => {
  return (
    <Container className='staff-turn-box'>
      <Box display='flex' alignItems='center' gap='2'>
        <Avatar size={36} src={data.staffAvatar} alt={data.staffName}>{data.staffName?.[0]}</Avatar>
        <Text variant='CONTENT_2' className='text-overflow'>{data.staffName}</Text>
      </Box>
    </Container>
  );
};
const Container = styled.div`
align-self: stretch;
position: relative;
.box-text {
  border: 1px solid #86909C;
  background: #F0F0F0;
  height: 32px;
  min-width: 200px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  position: relative;
  padding: 8px 12px;
  flex:1;
  align-self: stretch;
}
.CONTENT_2 {
  position: relative;
  z-index: 3;
  color: #1D2129;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
&.highlight {
  background: #FBD277;
  animation: glow 1s ease-in-out infinite;
  
  &::after {
    animation-delay: .4s;
  }
  .box-text {
    position: relative;
    z-index: 3;
    background: #FBD277;
    border: 1px solid #F5B945;
  }

}

&.staff-turn-box {
  border: 1px solid ${colorTheme.ink_2};
  background: #FFF;
  height: 32px;
  min-width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  position: relative;
  padding: 8px 12px;
  flex:1;
  align-self: stretch;

  &.highlight-turns {
    background: ${colorTheme.gold_1};
    border: 1px solid ${colorTheme.gold_5};
    animation: glow 1s ease-in-out infinite;
  }
  
  .index-text {
    width: 24px;
    height: 24px;
    border-radius: 100px;
    background: ${colorTheme.ink_1};
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 800;
    color: ${colorTheme.ink_5};

    &.highlight-index {
      color: ${colorTheme.ink_9};
      background: ${colorTheme.gold_5};
    }
  }

  .turns-text {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    color: ${colorTheme.ink_4};

    &.highlight-turns {
      color: ${colorTheme.teal_6};
    }
  }
}
`;
